// extracted by mini-css-extract-plugin
module.exports = {"circles":"Circles_circles__r92aY","circle":"Circles_circle__0zE4S"};